// @flow

import * as React from "react";
import { withRouter } from "react-router-dom";
import { format, isValid } from "date-fns";
import cx from "classnames";

import { datePickerDisplayFormat } from "../../utils/formats";
import DownloadPdf from "../DownloadPdf";

import styles from "./InquiryPage.scss";
import NavTabs from "../Navbar/PortalNavbar/NavTabs/NavTabs";
import PageHeader from "../PageHeader";
import Preloader from "../Preloader";
import Footer from "../Footer";
import Status from "../Status";

type InquiryPageProps = {
  children: React.Node,
  companyName: string,
  issuedOn: ?Date,
  match: {
    params: {
      id: number
    }
  },
  isLoadingData: boolean,
  backPath: string,
  tabs: number => any,
  site: string,
  status: string,
  generatePDFtemplate?: () => void,
  downloadPdf?: () => void,
  pdfData: any,
  headerBase: string
};

const InquiryPage = ({
  isLoadingData,
  match,
  companyName,
  issuedOn,
  children,
  backPath,
  tabs,
  site,
  status,
  generatePDFtemplate,
  pdfData,
  downloadPdf,
  headerBase
}: InquiryPageProps) => {
  const { id } = match.params;

  return (
    <div className={styles.inquiryPage}>
      {isLoadingData && <div className={styles.loadingOverlay} />}
      <div className={styles.navTabs}>
        {!isLoadingData && <NavTabs tabs={tabs(id)} backPath={backPath} />}
      </div>
      <div className={styles.wrapper}>
        <div className={styles.pageContent}>
          <div className={styles.headerContainer}>
            <PageHeader
              className={styles.appHeader}
              header={`${headerBase} ${companyName}`}
              subheader={`vom ${
                issuedOn && isValid(issuedOn) ? format(issuedOn, datePickerDisplayFormat) : "-"
              }`}
              isBoldHeader
              isSmallSubheader
            />
            {(generatePDFtemplate || downloadPdf) && (
              <DownloadPdf
                pdfData={pdfData}
                generatePDFtemplate={generatePDFtemplate}
                downloadPdf={downloadPdf}
              />
            )}
          </div>
          <div className={cx(styles.content)}>
            {isLoadingData && (
              <div className={styles.loader}>
                <Preloader />
              </div>
            )}
            {children}
            {status && (
              <div className={styles.statusWrapper}>
                <Status renderAsBlock site={site} status={status} />
              </div>
            )}
          </div>
        </div>
        <Footer type="portal" />
      </div>
    </div>
  );
};

InquiryPage.defaultProps = {
  headerBase: "Anfrage"
};

export default withRouter(InquiryPage);
